import { useSearchParamsCustom } from '@utils/searchparams.uitilites';

export const useLeadSourceParamsLaunchTeaser = () => {
  const urlSearchParams = useSearchParamsCustom();

  const getLeadSourceParamsLaunchTeaser = () => {
    const enquiryCategory = urlSearchParams.get('enquiryCategory');
    const enquiryTrigger = urlSearchParams.get('enquiryTrigger');
    const offer = urlSearchParams.get('offer');
    const salesOrigin = urlSearchParams.get('salesOrigin');
    const leadType = urlSearchParams.get('leadType');
    const corporateWealthName = urlSearchParams.get('corporateWealthName');
    const campaignName = urlSearchParams.get('campaignname');

    return {
      enquiryCategory: enquiryCategory ?? undefined,
      enquiryTrigger: enquiryTrigger ?? undefined,
      offerCode: offer ?? undefined,
      salesOrigin: salesOrigin ?? undefined,
      leadType: leadType ?? undefined,
      corporateWealthName: corporateWealthName ?? undefined,
      campaignName: campaignName ?? undefined,
    };
  };

  return {
    urlSearchParams,
    getLeadSourceParamsLaunchTeaser,
  };
};
